// extracted by mini-css-extract-plugin
module.exports = {"root":"NewsletterPromoWrapper__root--3BPiW","header":"NewsletterPromoWrapper__header--mWFAk"};